var exports = {
  "q": "GuildAcronym.module__acronym___Y1BUN2",
  "Q": "GuildAcronym.module__text___Y1BUN2",
};

module.exports = exports;
